export type ProductFeature = {
  id: string;
  icon: 'wifi' | 'battery' | 'palette' | 'ruler' | 'magnet' | 'sparkles';
  title: string;
  body: string;
  /** Approved circular MarineForceLED feature artwork shown in the console viewer. */
  image: string;
  imageAlt: string;
  metric: { value: number; decimals?: number; unit: string; label: string };
};

export const productFeatures: ProductFeature[] = [
  {
    id: 'wireless',
    icon: 'wifi',
    title: 'Wireless',
    body: 'No cords. No hassle.',
    image: 'https://cdn.magicpatterns.com/uploads/hjbctfaqjWt7dFRstFXgE3/B7E0293A-3004-444A-8009-B3A4949B0DEC.png',
    imageAlt: 'M1 PRO wireless light with 13 LEDs glowing in RGB',
    metric: { value: 0, unit: 'wires', label: 'to the pool' },
  },
  {
    id: 'battery',
    icon: 'battery',
    title: '3000mAh Battery',
    body: 'Up to 70 hours per charge. USB-C cable included.',
    image: 'https://cdn.magicpatterns.com/uploads/xjhcFS7DN7LmpaaB9b8Gsf/631066AC-D5EB-462E-B456-3244FD52AE93.png',
    imageAlt: 'M1 PRO with its rechargeable 3000mAh battery and USB-C port',
    metric: { value: 3000, unit: 'mAh', label: 'rechargeable battery' },
  },
  {
    id: 'rgb',
    icon: 'palette',
    title: '16 Colors',
    body: 'Dynamic colors. Endless atmosphere.',
    image: 'https://cdn.magicpatterns.com/uploads/nSHtK44oRprHkrwMcuYZ5A/C1B2EE91-D742-4732-98C0-FF6B2864D33B.png',
    imageAlt: 'M1 PRO showing 16 RGB colors and dynamic lighting modes',
    metric: { value: 16, unit: 'colors', label: 'RGB + dynamic modes' },
  },
  {
    id: 'compact',
    icon: 'ruler',
    title: 'Compact Design',
    body: 'Low profile. Professional performance.',
    image: 'https://cdn.magicpatterns.com/uploads/mDVYM52KdvPDiECvBsg8bF/1D38AE36-948E-4A64-9768-DFB6C24A00C0.png',
    imageAlt: 'Compact, low-profile M1 PRO beside its magnetic base',
    metric: { value: 1.2, decimals: 1, unit: 'in', label: 'slim profile' },
  },
  {
    id: 'magnetic',
    icon: 'magnet',
    title: 'Magnetic Mount',
    body: 'Install once. Swap in seconds. One mount. One perfect position. Every time.',
    image: 'https://cdn.magicpatterns.com/uploads/ok9btVgqsR7x4FPY68HK9w/8F565AD7-517E-485C-9040-061F468E7CED.png',
    imageAlt: 'M1 PRO attaching magnetically to its white mounting base',
    metric: { value: 3.3, decimals: 1, unit: 'in', label: 'matched-diameter base' },
  },
  {
    id: 'leds',
    icon: 'sparkles',
    title: '13 LED Array',
    body: '13 LED lenses. Professional-grade lighting.',
    image: 'https://cdn.magicpatterns.com/uploads/oadqgpkopjQ55UTKyKmT7K/57366166-6995-42A0-9C01-D6401DA390C8.png',
    imageAlt: 'Close-up of the M1 PRO 13-LED lens array',
    metric: { value: 13, unit: 'LEDs', label: 'per light' },
  },
];
